module.exports = __webpack_public_path__ + "static/media/cq_conferma_salva b.cce9c1cc.svg";